import type { MouseEvent } from 'react'
import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import TextLink from 'LuxKit/TextLink'
import useListTruncator from 'hooks/useListTruncator'
import styled from 'styled-components'

const DEFAULT_VISIBLE_ITEMS = 3

const ToggleText = styled(TextLink)`
  white-space: nowrap;
`

interface Props {
  evergreenInclusions?: Array<App.PackageInclusion>
  visibleItems?: number
}

function CruiseEvergreenInclusionList({ evergreenInclusions, visibleItems = DEFAULT_VISIBLE_ITEMS }: Props) {
  const intl = useIntl()
  const [showAll, setShowAll] = useState(false)
  const inclusions = evergreenInclusions ?? []
  const [visibleInclusions, hiddenInclusions] = useListTruncator(showAll ? undefined : visibleItems, inclusions)
  const hiddenCount = hiddenInclusions.length

  const onShowMoreClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setShowAll(true)
  }, [])

  const onShowLessClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setShowAll(false)
  }, [])

  return <>
    {!!visibleInclusions.length && <VerticalSpacer gap={8}>
      {visibleInclusions.map((inclusion, index) => {
        const shouldShowMoreToggle = !showAll && hiddenCount > 0 && index === visibleInclusions.length - 1

        return <OfferInclusionItem
          key={inclusion.id}
          inclusion={inclusion}
          endIcon={shouldShowMoreToggle && <ToggleText
            size="medium"
            onClick={onShowMoreClick}
          >
            {intl.formatMessage({
              id: 'UtomIJF0H414JjvYQR_T',
              defaultMessage: '+{count} more',
              description: 'Action to expand and show more evergreen cruise inclusions',
            }, { count: hiddenCount })}
          </ToggleText>}
        />
      })}

      {showAll && inclusions.length > visibleItems && <ToggleText
        size="medium"
        onClick={onShowLessClick}
      >
        {intl.formatMessage({
          id: 'H9GcFGylDblx4phqaAZa',
          defaultMessage: 'Show less',
          description: 'Action to collapse expanded evergreen cruise inclusions',
        })}
      </ToggleText>}
    </VerticalSpacer>}
  </>
}

export default CruiseEvergreenInclusionList
